var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_14656_12007",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 44,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 42,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.95754 9.95169 1 20.9942 1C32.0366 1 40.9883 9.95754 40.9883 21C40.9883 32.0425 32.0366 41 20.9942 41C9.95169 41 1 32.0425 1 21Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166667 20.9942C0.166667 9.49145 9.49145 0.166667 20.9942 0.166667C32.4969 0.166667 41.8216 9.49145 41.8216 20.9942H40.155C40.155 10.4119 31.5764 1.83333 20.9942 1.83333C10.4119 1.83333 1.83333 10.4119 1.83333 20.9942H0.166667ZM41.8216 22.6725C41.8216 34.1752 32.4969 43.5 20.9942 43.5C9.49145 43.5 0.166667 34.1752 0.166667 22.6725L1.83333 21.0058C1.83333 30.6676 10.4119 38.5 20.9942 38.5C31.5764 38.5 40.155 30.6676 40.155 21.0058L41.8216 22.6725ZM20.9942 43.5C9.49145 43.5 0.166667 34.1752 0.166667 22.6725V20.9942C0.166667 9.49145 9.49145 0.166667 20.9942 0.166667V1.83333C10.4119 1.83333 1.83333 10.4119 1.83333 20.9942V21.0058C1.83333 30.6676 10.4119 38.5 20.9942 38.5V43.5ZM20.9942 0.166667C32.4969 0.166667 41.8216 9.49145 41.8216 20.9942V22.6725C41.8216 34.1752 32.4969 43.5 20.9942 43.5V38.5C31.5764 38.5 40.155 30.6676 40.155 21.0058V20.9942C40.155 10.4119 31.5764 1.83333 20.9942 1.83333V0.166667Z",
    fill: "#90A8C1",
    fillOpacity: 0.3,
    mask: "url(#path-1-outside-1_14656_12007)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9855 21.0007C40.9855 31.102 33.5003 39.4529 23.7764 40.808C22.8672 40.9341 21.937 41 20.9928 41C19.9028 41 18.8325 40.9131 17.7902 40.745C8.27086 39.2118 1 30.9548 1 21.0007C1 9.95491 9.95198 1 20.9942 1C32.0363 1 40.9883 9.95491 40.9883 21.0007H40.9855Z",
    fill: "#1C1C1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10822 9.82812L18.3292 22.1604L9.05078 32.1874H11.1396L19.2636 23.409L25.827 32.1874H32.9339L23.1946 19.1614L31.8314 9.82812H29.7426L22.2616 17.9128L16.2166 9.82812H9.10961H9.10822ZM12.1791 11.3669H15.4433L29.8603 30.6486H26.5961L12.1791 11.3669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareX);
export default __webpack_public_path__ + "static/media/ShareX.70db809094fb176ea26a5c63844cadf1.svg";
export { ForwardRef as ReactComponent };